<template>
  <div>
    <v-row v-if="!$store.state.recordingEng">
      <v-col class="text-center">
        <v-btn :href="`https://storage.googleapis.com/ensemble_forms/performance_site//combined_forms.pdf`" target="_blank" color="primary">Download Performance Forms</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card :loading="loading">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left">Time</th>
                <th class="text-left">Ensemble</th>
                <th class="text-left">Classification</th>
                <th class="text-left">Group Size</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(slot, i) in slots">
                <tr v-if="i == 0 || slot.date != slots[i-1].date" :key="slot.date">
                  <td colspan=4 class="text-center white--text title grey darken-1">{{slot.date | formatDate}}</td>
                </tr>
                <tr :key="slot.id">
                  <td v-if="slot.break_or_lunch != ''" colspan=4 class="text-center white--text grey subtitle-1 lighten-1">{{slot.break_or_lunch}}</td>
                  <template v-else>
                    <td>{{ slot.time_start | formatTime }}</td>
                    <td>{{ slot.ensemble_school_name + ' ' + slot.ensemble_category }}</td>
                    <td>{{ slot.ensemble_classification }}</td>
                    <td>{{ slot.ensemble_size }}</td>
                  </template>
                </tr>
              </template>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'
import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  data() {
    return {
      site_id: null,
      slots: null,
      loading: true
    }
  },
  filters: {
    formatDate: function(date) {
      return moment.utc(date).format('MMMM Do, YYYY')
    },
    formatTime: function(time) {
      return moment.utc(time).format('h:mm a')
    }
  },
  mounted() {
    const vm = this
    const id = vm.$store.state.assignment
    const getOpusApi = firebase.functions().httpsCallable('getOpusApi')

    getOpusApi({
      table: `vendor_assignments/${id}`,
      params: {
        include: 'performance_slots'
      }
    }).then(function(response) {
      // console.log(response.data.result)
      vm.site_id = response.data.result.performance_site.id
      vm.slots = response.data.result.performance_slots
      vm.loading = false
    })
  }
}
</script>